import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Hero() {
  return <section className="bg-white pt-[60px] pb-10 md:pt-36 md:pb-24 px-4 overflow-hidden" data-id="element-138">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="lg:col-span-7 pt-[0px] pb-[0px] space-y-[24px]" data-id="element-140">
          <div className="inline-block bg-primary/10 text-primary font-semibold px-4 py-1.5 rounded-full text-sm" data-id="element-141">
            Creado para mamás latinas en USA
          </div>

          <div className="space-y-4" data-id="element-142">
            <h1 className="text-4xl md:text-5xl lg:text-6xl text-dark font-display font-extrabold tracking-headline leading-tight" data-id="element-143">
              Lanza Tu Primer Producto Digital Este Fin de Semana —{' '}
              <span className="text-primary" data-id="element-144">
                La IA Hace el Trabajo Pesado por Ti
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-body leading-relaxed font-medium" data-id="element-145">
              Un sistema paso a paso para crear, diseñar y vender tu producto
              digital desde el celular. Sin experiencia. Sin aparecer en cámara.
              Sin invertir meses.
            </p>
          </div>

          <ul className="space-y-2.5 text-base md:text-lg text-dark font-medium" data-id="element-146">
            {['La IA escribe, diseña y estructura por ti', 'Paso a paso: solo sigue el sistema desde tu celular', 'Descarga inmediata — empiezas hoy mismo'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-147">
                <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0" data-id="element-148" />
                <span data-id="element-149">{item}</span>
              </li>)}
          </ul>

          <div className="pt-2 space-y-3" data-id="element-150">
            <motion.a href="#offer" className="shimmer-cta block w-full sm:w-auto bg-cta hover:bg-rose-600 text-white font-bold rounded-full px-8 py-5 text-lg shadow-xl shadow-cta/20 text-center relative overflow-hidden" animate={{
            scale: [1, 1.04, 1]
          }} transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.07
          }} whileTap={{
            scale: 0.97
          }} data-id="element-151">
              Quiero mi sistema por $6.36 →
            </motion.a>
            <p className="text-sm text-body text-center sm:text-left font-medium flex items-center justify-center sm:justify-start gap-1.5" data-id="element-152">
              <ShieldCheckIcon className="w-4 h-4 text-primary/60" data-id="element-153" />
              Pago único · Acceso de por vida · Garantía 7 días
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="lg:col-span-5 relative" data-id="element-154">
          <div className="relative rounded-[24px] overflow-hidden shadow-2xl border border-border group" data-id="element-155">
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 pointer-events-none" data-id="element-156"></div>
            <img src="https://cdn.magicpatterns.com/uploads/mozDazfnqDLdMp54N9PFAe/portada.webp" alt="Sistema Mamá IA - Tu Negocio Digital en 48 Horas" className="w-full h-auto object-cover aspect-[4/5] transform group-hover:scale-105 transition-transform duration-700" data-id="element-157" />
            <div className="absolute bottom-6 left-6 right-6 z-20" data-id="element-158">
              <div className="bg-white/95 backdrop-blur-sm shadow-xl border border-white/20 rounded-[20px] p-5 transform translate-y-0 group-hover:-translate-y-2 transition-transform duration-300" data-id="element-159">
                <p className="text-dark font-display font-bold text-xl mb-1" data-id="element-160">
                  Sistema Mamá IA
                </p>
                <p className="text-primary font-medium text-sm" data-id="element-161">
                  De cero a tu primer producto en 48 horas
                </p>
              </div>
            </div>
          </div>

          {/* Decorative elements for premium feel */}
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-primary/10 rounded-full blur-2xl -z-10" data-id="element-162"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-cta/10 rounded-full blur-2xl -z-10" data-id="element-163"></div>
        </motion.div>
      </div>
    </section>;
}